export default "__VITE_ASSET__218f319e__"